import { BlogContent } from "./BlogContent";
import { BlogImage } from "./BlogImage";

export class Blog {
    public id: number;
    public name: string;
    public status: number;
    public createdAt: string;
    public updatedAt: string;
    public publishedAt: string;
    public deletedAt: string;
    public contents: BlogContent[];
    public images: BlogImage[];

    static fromDto(b): Blog {
        const blog = new Blog();

        if (!b) {
            return null;
        }

        blog.id = b.id;
        blog.name = b.name;
        blog.status = b.status;
        blog.createdAt = b.createdAt;
        blog.updatedAt = b.updatedAt;
        blog.publishedAt = b.publishedAt;
        blog.deletedAt = b.deletedAt;
        blog.contents = b.contents.map(c => BlogContent.fromDto(c));
        blog.images = b.images.map(c => BlogImage.fromDto(c));

        return blog;
    }
}
